import AppLayout from "@/components/layout/AppLayout";
import React from "react";

function PageNotFound() {
  return (
    <AppLayout>
      <div className="bg-white rounded-[12px] px-4 sm:px-6 md:px-[32px] w-full overflow-hidden">
        <div
          className={`flex flex-col h-[calc(100vh-140px)] mb-2 overflow-x-auto justify-center items-center`}
        >
          <p className="text-[#1F1F1F] text-[24px] font-bold mb-[9px]">
            Page Not Found
          </p>
          <p className="text-[#1F1F1F] text-[24px] font-medium mb-[28px]">
            The page you are looking for does not exist or has been moved.
          </p>
          {/* <Button
        className="w-[195px] h-[48px] bg-[#5C88C5] text-white"
        onClick={() => navigate("/assignments/add-assignment")}
      >
        Add Assignment
      </Button> */}
        </div>
      </div>
    </AppLayout>
  );
}

export default PageNotFound;
